export const API_KEYS_REQUEST = 'API_KEYS_REQUEST'
export function apiKeysRequest() {
    return {
        type: API_KEYS_REQUEST
    }
}

export const API_KEYS_SUCCESS = 'API_KEYS_SUCCESS'
export function apiKeysSuccess(apiKeys) {
    return {
        type: API_KEYS_SUCCESS,
        apiKeys
    }
}

export const API_KEYS_ERROR = 'API_KEYS_ERROR'
export function apiKeysError() {
    return {
        type: API_KEYS_ERROR
    }
}

export const CREATE_API_KEY = 'CREATE_API_KEY'
export function createApiKey(body) {
    return {
        type: CREATE_API_KEY,
        body
    }
}

export const CREATE_API_KEY_SUCCESS = 'CREATE_API_KEY_SUCCESS'
export function createApiKeySuccess() {
    return {
        type: CREATE_API_KEY_SUCCESS
    }
}

export const CREATE_API_KEY_ERROR = 'CREATE_API_KEY_ERROR'
export function createApiKeyError() {
    return {
        type: CREATE_API_KEY_ERROR
    }
}

export const DELETE_API_KEY = 'DELETE_API_KEY'
export function deleteApiKey(id) {
    return {
        type: DELETE_API_KEY,
        id
    }
}

export const DELETE_API_KEY_SUCCESS = 'DELETE_API_KEY_SUCCESS'
export function deleteApiKeySuccess() {
    return {
        type: DELETE_API_KEY_SUCCESS
    }
}

export const DELETE_API_KEY_ERROR = 'DELETE_API_KEY_ERROR'
export function deleteApiKeyError() {
    return {
        type: DELETE_API_KEY_ERROR
    }
}

export const API_KEY_REQUEST = 'API_KEY_REQUEST'
export function apiKeyRequest(id) {
    return {
        type: API_KEY_REQUEST,
        id
    }
}

export const API_KEY_SUCCESS = 'API_KEY_SUCCESS'
export function apiKeySuccess(apiKey) {
    return {
        type: API_KEY_SUCCESS,
        apiKey
    }
}

export const API_KEY_ERROR = 'API_KEY_ERROR'
export function apiKeyError() {
    return {
        type: API_KEY_ERROR
    }
}
